import { Mark } from "../chrome/Mark";

/** The staff doors' head: the site's brand lockup, the mark beside the word. */
export function AuthBrand() {
  return (
    <div className="auth-brand">
      <Mark size={38} />
      DuraLex
    </div>
  );
}
